import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Promise() {
  return <section className="pt-10 pb-4 md:py-20 px-6 max-w-2xl mx-auto" data-id="element-99">
      <FadeIn data-id="element-100">
        <div className="space-y-5 md:space-y-8 text-lg text-stone-700 leading-relaxed" data-id="element-101">
          <p className="font-medium text-olive-900 text-xl border-l-4 border-gold-500 pl-6 italic font-serif" data-id="element-102">
            Here is my promise to you: You won't have to wait 40 years to see if
            this works.
          </p>

          <p data-id="element-103">
            The moment you download this guide, you're going to skip to the{' '}
            <strong className="text-medBlue-700" data-id="element-104">
              'Sunset Reframing' technique
            </strong>
            . It takes <strong className="text-olive-900" data-id="element-105">60 seconds</strong>.
            You'll use it tonight.
          </p>

          <p data-id="element-106">
            For the first time in months (or years), the 'browser tabs' in your
            brain will close.{' '}
            <strong className="text-olive-900" data-id="element-107">The noise will stop.</strong>{' '}
            You'll fall asleep not because you're exhausted, but because{' '}
            <em className="font-medium text-olive-800" data-id="element-108">you are calm.</em>
          </p>

          <p data-id="element-109">
            Tomorrow morning, you won't wake up reached for your phone in a
            panic. You'll wake up with the same{' '}
            <strong className="text-olive-900" data-id="element-110">
              steady, purposeful clarity
            </strong>{' '}
            of an Okinawan elder.
          </p>

          <p className="text-xl font-serif font-medium text-olive-900 py-1 md:py-2 text-center" data-id="element-111">
            This solves your <span className="text-medBlue-700" data-id="element-112">'Tonight'</span>{' '}
            problem so you can actually enjoy your{' '}
            <span className="text-medBlue-700" data-id="element-113">'Future'</span> self.
          </p>
        </div>
      </FadeIn>
    </section>;
}